module.exports = __webpack_public_path__ + "static/media/stockhausen_wolf_2.910dbe74.jpg";